export const EXPORT_LEADS_AS_XLSX_REQUEST = 'EXPORT_LEADS_AS_XLSX_REQUEST';
export const EXPORT_LEADS_AS_XLSX_SUCCESS = 'EXPORT_LEADS_AS_XLSX_SUCCESS';
export const EXPORT_LEADS_AS_XLSX_ERROR = 'EXPORT_LEADS_AS_XLSX_ERROR';

export const LEADS_PAGINATION_SIZE = 20;

export const LEADS_SECTION = {
  OPEN: 'LEADS_SECTION_OPEN',
  CLOSED: 'LEADS_SECTION_CLOSED',
};

export const LEADS_URLS = {
  CLOSED_LEADS_URL: '/dealer/leads/closed-leads',
  OPEN_LEADS_URL: '/dealer/leads/open-leads',
};

export const LEADTILE_ICONS = {
  ATTENTION_ICON: 'if-icon-attention',
  AVATAR_ICON: 'if-icon-avatar',
  PHONE_ICON: 'if-icon-call',
  CHAT_ICON: 'if-icon-chat',
  EMAIL_ICON: 'if-icon-mail',
};

export const LEAD_TYPES = {
  TYPE_CHAT: 'chat',
  TYPE_EMAIL: 'email',
  TYPE_FACEBOOK_AD: 'facebook-ad',
  TYPE_MARKETPLACE: 'marketplace',
  TYPE_PHONE: 'phone-call',
  TYPE_CALLBACK: 'callback',
  TYPE_VIDEO: 'video',
};

export const LEAD_FILTER_TYPES = {
  EMAIL: 'EMAIL',
  PHONECALL: 'PHONECALL',
  CHAT: 'CHAT',
};

export const LEAD_FILTER_OPEN_LEADS_STATUSES = {
  NOT_REPORTED: 'NOT_REPORTED',
  SOLD: 'SOLD',
  NOT_SOLD: 'NOT_SOLD',
};

export const LEAD_FILTER_CLOSED_LEADS_STATUSES = {
  ALL: 'ALL',
  SOLD_CONFIRMED: 'SOLD_CONFIRMED',
  NOT_SOLD_CONFIRMED: 'NOT_SOLD_CONFIRMED',
  NOT_CONFIRMED: 'NOT_CONFIRMED',
};

export const LEAD_SALE_STATES = {
  COMPLETED: 'COMPLETED',
  DENIED: 'DENIED',
  PENDING: 'PENDING',
  OPEN: 'OPEN',
};

export const LEAD_CATEGORIES = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
};

export const LEAD_BILLING_STATES = {
  BILLED: 'BILLED',
  OPEN: 'OPEN',
};
